(function() {
  'use strict';

  /**
   * Parse price string and extract numeric value
   * @param {string} priceText - Price text like "$39.99 USD"
   * @returns {object} - { amount: number, currency: string, unit: string }
   */
  function parsePrice(priceText) {
    if (!priceText || typeof priceText !== 'string') {
      return null;
    }

    // Match currency symbol and amount
    var match = priceText.trim().match(/^([^\d]*?)([\d,]+\.?\d*)(.*?)$/);
    if (!match) {
      return null;
    }

    var currency = match[1].trim();
    var amount = parseFloat(match[2].replace(/,/g, ''));
    var unit = match[3].trim();

    return {
      amount: amount,
      currency: currency || '$',
      unit: unit || ''
    };
  }

  /**
   * Format price for display
   * @param {number} amount - Price amount
   * @param {string} currency - Currency symbol
   * @param {string} unit - Currency unit (e.g., "USD")
   * @returns {string} - Formatted price string
   */
  function formatPrice(amount, currency, unit) {
    var formatted = currency + amount.toFixed(2);
    if (unit) {
      formatted += ' ' + unit;
    }
    return formatted;
  }

  /**
   * Calculate discounted price
   * @param {number} originalPrice - Original price amount
   * @param {number|object} discount - Discount value (percentage number or object with percentage/fixed)
   * @returns {number} - Discounted price amount
   */
  function calculateDiscountedPrice(originalPrice, discount) {
    if (typeof discount === 'number') {
      // Percentage discount
      return originalPrice * (1 - discount / 100);
    } else if (typeof discount === 'object') {
      if (discount.percentage !== undefined) {
        // Percentage discount from object
        return originalPrice * (1 - discount.percentage / 100);
      } else if (discount.fixed !== undefined) {
        // Fixed amount discount
        return Math.max(0, originalPrice - discount.fixed);
      }
    }
    return originalPrice;
  }

  /**
   * Apply discount to a single price element
   * @param {HTMLElement} priceElement - The price element (could be .price, #total-price, etc.)
   * @param {number|object} discount - Discount value
   */
  /**
   * Check if a product should be excluded from discount
   * @param {HTMLElement} element - The element to check
   * @returns {string|null} - The product name if excluded, null otherwise
   */
  function isExcludedProduct(element) {
    var excludedProductNames = [
      'Hydrate + Balance | Single (Classic)',
      'Crea tu Combo | Hydrate + Balance',
      'Holiday Hydration Bundle',
      'Paquete de Hidratación Festivo', 
      'Paquete Festivo de Hidratación + Creatina',
      'Holiday Hydration + Creatine Bundle'
    ];
    
    // Function to find product name in element or parent elements
    function findProductName(el) {
      var elementToCheck = el;
      var productName = null;
      
      // Check up to 10 levels up the DOM tree for data-product-name attribute
      for (var level = 0; level < 10 && elementToCheck; level++) {
        productName = elementToCheck.getAttribute('data-product-name');
        if (productName) {
          return productName.trim();
        }
        elementToCheck = elementToCheck.parentElement;
      }
      
      // Also check for common product wrapper classes
      // Use closest() if available, otherwise traverse manually
      var productWrapper = null;
      if (el.closest) {
        productWrapper = el.closest('[class*="product"], [id*="product"], [data-product-id]');
      } else {
        // Fallback: manually traverse up looking for product-related elements
        var current = el.parentElement;
        while (current && current !== document.body && current !== document.documentElement) {
          var className = current.className || '';
          var id = current.id || '';
          if (className.indexOf('product') !== -1 || 
              id.indexOf('product') !== -1 || 
              current.hasAttribute('data-product-id')) {
            productWrapper = current;
            break;
          }
          current = current.parentElement;
        }
      }
      
      if (productWrapper) {
        productName = productWrapper.getAttribute('data-product-name');
        if (productName) {
          return productName.trim();
        }
      }
      
      return null;
    }
    
    var productName = findProductName(element);
    
    if (productName) {
      // Check if the product name matches any excluded names
      var normalizedProductName = productName.toLowerCase().trim();
      
      for (var i = 0; i < excludedProductNames.length; i++) {
        var normalizedExcluded = excludedProductNames[i].toLowerCase().trim();
        // Try exact match first
        if (productName === excludedProductNames[i] || normalizedProductName === normalizedExcluded) {
          return productName; // Return product name to indicate it's excluded
        }
        // Also try partial match in case of extra whitespace or slight variations
        if (productName.indexOf(excludedProductNames[i]) !== -1 || 
            excludedProductNames[i].indexOf(productName) !== -1) {
          return productName; // Return product name to indicate it's excluded
        }
      }
    }
    
    return null; // Not excluded
  }

  /**
   * Restore original price if discount was applied
   * @param {HTMLElement} priceElement - The price element
   */
  function restoreOriginalPrice(priceElement) {
    var originalPrice = priceElement.getAttribute('data-original-price');
    
    // Try to extract original price from struck-through span if available
    var struckThroughSpan = priceElement.querySelector('span[style*="line-through"]');
    if (struckThroughSpan && !originalPrice) {
      originalPrice = struckThroughSpan.textContent.trim();
      // Store it for future reference
      if (originalPrice) {
        priceElement.setAttribute('data-original-price', originalPrice);
      }
    }
    
    if (!originalPrice) {
      // If we can't find the original price, we can't restore it
      console.warn('Cannot restore original price: no stored original price found for element:', priceElement);
      console.warn('Element HTML:', priceElement.outerHTML.substring(0, 200));
      return;
    }

    console.log('Restoring original price:', originalPrice, 'for element:', priceElement);

    // Check if discount HTML exists anywhere in the element or its children
    var hasDiscountHTML = priceElement.innerHTML.indexOf('line-through') !== -1 ||
                         priceElement.querySelector('span[style*="line-through"]') !== null;
    
    if (hasDiscountHTML) {
      console.log('Found discount HTML, restoring...');
      
      // Find the container where discount spans were inserted
      // Check direct children first
      var foundContainer = false;
      for (var i = 0; i < priceElement.children.length; i++) {
        var child = priceElement.children[i];
        if (child.tagName === 'SPAN') {
          var childHTML = child.innerHTML || '';
          if (childHTML.indexOf('line-through') !== -1 || 
              child.querySelector('span[style*="line-through"]') !== null) {
            // This span contains the discount HTML - replace it with original price
            console.log('Replacing discount HTML in child span with:', originalPrice);
            child.innerHTML = originalPrice;
            foundContainer = true;
            break;
          }
        }
      }
      
      if (!foundContainer) {
        // Discount HTML is directly in priceElement - replace innerHTML
        console.log('Replacing discount HTML directly in element with:', originalPrice);
        priceElement.innerHTML = originalPrice;
      }
    } else {
      // No discount HTML found - check if element has data-discount-applied attribute
      if (priceElement.hasAttribute('data-discount-applied')) {
        // Even if no discount HTML, restore the text content
        console.log('No discount HTML found, but has data-discount-applied, restoring text content:', originalPrice);
        priceElement.textContent = originalPrice;
      } else {
        console.log('No discount HTML or data-discount-applied attribute found, element may not need restoration');
      }
    }
    
    // Remove the discount-applied marker
    priceElement.removeAttribute('data-discount-applied');
    
    console.log('Restoration complete for element:', priceElement);
  }

  /**
   * Find product name for an element
   * @param {HTMLElement} element - The element to check
   * @returns {string|null} - The product name or null
   */
  function findProductNameForElement(element) {
    var elementToCheck = element;
    var productName = null;
    
    // Check up to 10 levels up the DOM tree for data-product-name attribute
    for (var level = 0; level < 10 && elementToCheck; level++) {
      productName = elementToCheck.getAttribute('data-product-name');
      if (productName) {
        return productName.trim();
      }
      elementToCheck = elementToCheck.parentElement;
    }
    
    // Also check for common product wrapper classes
    var productWrapper = null;
    if (element.closest) {
      productWrapper = element.closest('[class*="product"], [id*="product"], [data-product-id]');
    } else {
      var current = element.parentElement;
      while (current && current !== document.body && current !== document.documentElement) {
        var className = current.className || '';
        var id = current.id || '';
        if (className.indexOf('product') !== -1 || 
            id.indexOf('product') !== -1 || 
            current.hasAttribute('data-product-id')) {
          productWrapper = current;
          break;
        }
        current = current.parentElement;
      }
    }
    
    if (productWrapper) {
      productName = productWrapper.getAttribute('data-product-name');
      if (productName) {
        return productName.trim();
      }
    }
    
    return null;
  }

  /**
   * Add "Buy one get 2" message for specific products
   * @param {HTMLElement} priceElement - The price element
   */
  function addBuyOneGetTwoMessage(priceElement) {
    // Check if message already exists (either as sibling or inside parent)
    var existingMessage = priceElement.parentElement && 
                         priceElement.parentElement.querySelector('.buy-one-get-two-message');
    if (existingMessage) {
      return; // Message already exists
    }
    
    // Get product name
    var productName = findProductNameForElement(priceElement);
    
    // Check if this is a specific product that needs the message
    var productsWithMessage = [
      'Hydrate + Balance | Single (Classic)',
      'Crea tu Combo | Hydrate + Balance'
    ];
    
    var shouldShowMessage = productsWithMessage.indexOf(productName) !== -1;
    
    if (shouldShowMessage) {
      // Check if .price is inside a button
      var isInsideButton = false;
      var current = priceElement.parentElement;
      while (current && current !== document.body && current !== document.documentElement) {
        if (current.tagName === 'BUTTON') {
          isInsideButton = true;
          break;
        }
        current = current.parentElement;
      }
      
      // Also try closest() if available
      if (!isInsideButton && priceElement.closest) {
        var buttonParent = priceElement.closest('button');
        isInsideButton = buttonParent !== null;
      }
      
      // Create the message element
      var messageElement = document.createElement('span');
      messageElement.className = 'buy-one-get-two-message';
      
      // Set text based on product name (Spanish for "Crea tu Combo", English for others)
      var messageText = productName === 'Crea tu Combo | Hydrate + Balance' 
        ? 'Compra uno lleva 2' 
        : 'Buy one get 2';
      messageElement.textContent = messageText;
      messageElement.style.background = 'rgb(231, 76, 60)';
      messageElement.style.fontSize = '0.9em';
      messageElement.style.fontWeight = 'bold';
      messageElement.style.marginTop = '5px';
      messageElement.style.color = '#fff';
      messageElement.style.borderRadius = '10px';
      
      // Apply different styles based on context
      if (isInsideButton) {
        // Styles for .price inside button
        messageElement.style.padding = '5px';
        messageElement.style.float = 'right';
      } else {
        // Default styles for .price not inside button
        messageElement.style.display = 'inline-block';
        messageElement.style.padding = '10px';
      }
      
      // Insert the message after the price element
      if (priceElement.parentElement) {
        priceElement.parentElement.insertBefore(messageElement, priceElement.nextSibling);
      } else {
        // If no parent, append as next sibling (unlikely but fallback)
        priceElement.after(messageElement);
      }
    }
  }

  function applyDiscountToElement(priceElement, discount) {
    // Check if this product should be excluded BEFORE checking if discount was applied
    var excludedProductName = isExcludedProduct(priceElement);
    
    if (excludedProductName) {
      console.log('Skipping discount for excluded product:', excludedProductName);
      
      // If discount was already applied, restore the original price
      if (priceElement.hasAttribute('data-discount-applied')) {
        console.log('Restoring original price for excluded product:', excludedProductName);
        restoreOriginalPrice(priceElement);
      }
      
      // Add "Buy one get 2" message for specific products
      var productsWithMessage = [
        'Hydrate + Balance | Single (Classic)',
        'Crea tu Combo | Hydrate + Balance'
      ];
      if (productsWithMessage.indexOf(excludedProductName) !== -1) {
        addBuyOneGetTwoMessage(priceElement);
      }
      
      return; // Skip applying discount to this element
    }

    // Check if discount has already been applied
    if (priceElement.hasAttribute('data-discount-applied')) {
      return;
    }

    // Try to find a span element first (existing structure)
    var priceSpan = null;
    var useElementDirectly = false;
    
    // Get the direct child span (not nested spans)
    for (var i = 0; i < priceElement.children.length; i++) {
      if (priceElement.children[i].tagName === 'SPAN') {
        priceSpan = priceElement.children[i];
        break;
      }
    }
    
    // Fallback to querySelector if no direct child span found
    if (!priceSpan) {
      priceSpan = priceElement.querySelector('span');
    }
    
    // If no span found, use the element itself
    if (!priceSpan) {
      priceSpan = priceElement;
      useElementDirectly = true;
    }

    var originalText;
    var originalPriceAttr = priceElement.getAttribute('data-original-price');
    
    // If we have a stored original price, use it
    if (originalPriceAttr) {
      originalText = originalPriceAttr;
    } else {
      if (useElementDirectly) {
        // Get original text directly from the element
        originalText = priceElement.textContent.trim();
      } else {
        // Check if the span already contains nested spans (discount was partially applied)
        var nestedSpans = priceSpan.querySelectorAll('span');
        if (nestedSpans.length > 0) {
          // Extract original from the first nested span (should be the struck-through one)
          originalText = nestedSpans[0].textContent.trim();
        } else {
          // Get original text from the span itself
          originalText = priceSpan.textContent.trim();
        }
      }
    }

    var priceData = parsePrice(originalText);
    
    if (!priceData) {
      console.warn('Could not parse price:', originalText);
      return;
    }

    var discountedAmount = calculateDiscountedPrice(priceData.amount, discount);
    
    // Store original price for future reference
    if (!originalPriceAttr) {
      priceElement.setAttribute('data-original-price', formatPrice(priceData.amount, priceData.currency, priceData.unit));
    }
    
    // Update the HTML structure - replace with discounted price display
    priceSpan.innerHTML = '<span style="text-decoration: line-through; opacity: 0.6; margin-right: 8px;">' + 
                          formatPrice(priceData.amount, priceData.currency, priceData.unit) + 
                          '</span>' +
                          '<span style="color: #e74c3c; font-weight: bold;">' + 
                          formatPrice(discountedAmount, priceData.currency, priceData.unit) + 
                          '</span>';
    
    // Mark as applied to prevent duplicate applications
    priceElement.setAttribute('data-discount-applied', 'true');
  }

  /**
   * Apply discount to all price elements on the page
   * @param {number|object} discount - Discount value (percentage number or object)
   * @param {string|array} selector - Optional CSS selector(s) (default: ['.price', '#total-price'])
   */
  window.applyPriceDiscount = function(discount, selector) {
    // Default selector supports .price, #total-price, and tybo card prices
    if (!selector) {
      selector = ['.price', '#total-price', '.product-card__price'];
    }
    
    // If single selector string, convert to array
    if (typeof selector === 'string') {
      selector = [selector];
    }
    
    if (discount === undefined || discount === null) {
      console.warn('Discount value is required');
      return;
    }

    var allPriceElements = [];
    
    // Query all selectors and combine results
    selector.forEach(function(sel) {
      var elements = document.querySelectorAll(sel);
      for (var i = 0; i < elements.length; i++) {
        allPriceElements.push(elements[i]);
      }
    });
    
    if (allPriceElements.length === 0) {
      console.warn('No price elements found with selector(s):', selector);
      return;
    }

    allPriceElements.forEach(function(element) {
      applyDiscountToElement(element, discount);
    });
  };

  /**
   * Check all price elements and restore any excluded products that have discounts
   */
  function restoreExcludedProducts() {
    // Find all price elements (include tybo card prices)
    var selectors = ['.price', '#total-price', '.product-card__price'];
    var allPriceElements = [];
    
    selectors.forEach(function(sel) {
      var elements = document.querySelectorAll(sel);
      for (var i = 0; i < elements.length; i++) {
        allPriceElements.push(elements[i]);
      }
    });
    
    // Check each price element for excluded products
    allPriceElements.forEach(function(element) {
      var excludedProductName = isExcludedProduct(element);
      if (excludedProductName) {
        // Check if this element has discount HTML (line-through style)
        var hasDiscountHTML = element.innerHTML.indexOf('line-through') !== -1 || 
                             element.querySelector('span[style*="line-through"]');
        
        // Check if it has data-discount-applied attribute
        var hasDiscountApplied = element.hasAttribute('data-discount-applied');
        
        if (hasDiscountHTML || hasDiscountApplied) {
          console.log('Restoring excluded product:', excludedProductName, 'element:', element);
          restoreOriginalPrice(element);
        }
        
        // Add "Buy one get 2" message for specific products
        var productsWithMessage = [
          'Hydrate + Balance | Single (Classic)',
          'Crea tu Combo | Hydrate + Balance'
        ];
        if (productsWithMessage.indexOf(excludedProductName) !== -1) {
          addBuyOneGetTwoMessage(element);
        }
      }
    });
  }

  // Auto-apply on DOM ready if discount is set via data attribute
  function autoApplyDiscounts() {
    // First, restore any excluded products that might already have discounts
    restoreExcludedProducts();
    
    // Support .price, #total-price, tybo card price with data-discount attribute
    var selectors = ['.price[data-discount]', '#total-price[data-discount]', '.product-card__price[data-discount]', '[data-discount][class*="price"]'];
    var allPriceElements = [];
    
    selectors.forEach(function(sel) {
      var elements = document.querySelectorAll(sel);
      for (var i = 0; i < elements.length; i++) {
        allPriceElements.push(elements[i]);
      }
    });
    
    allPriceElements.forEach(function(element) {
      var discountAttr = element.getAttribute('data-discount');
      var discount = parseFloat(discountAttr);
      if (!isNaN(discount)) {
        applyDiscountToElement(element, discount);
      }
    });
  }
  
  // Run restoreExcludedProducts on page load and also periodically check
  function initializeExclusionCheck() {
    restoreExcludedProducts();
    
    // Also check after a short delay in case discounts are applied dynamically
    setTimeout(function() {
      restoreExcludedProducts();
    }, 500);
    
    // Check again after a longer delay for dynamically loaded content
    setTimeout(function() {
      restoreExcludedProducts();
    }, 2000);
  }
  
  function runInitialDiscountLogic() {
    initializeExclusionCheck();
    autoApplyDiscounts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      runInitialDiscountLogic();
      // Re-run for dynamically loaded content (e.g. product cards in sections)
      setTimeout(runInitialDiscountLogic, 400);
      setTimeout(runInitialDiscountLogic, 1200);
    });
  } else {
    runInitialDiscountLogic();
    setTimeout(runInitialDiscountLogic, 400);
    setTimeout(runInitialDiscountLogic, 1200);
  }

})();


